import { Flex } from "@chakra-ui/react";
import { Control } from "react-hook-form";
import Field from "components/Input/Field/index";
import { ExportacaoContabilForm } from "features/exportacao-contabil/typings/index";
import { Input } from "@chakra-ui/input";

export default function RowTableHistorico({
  control,
  data,
  index,
  nameField,
}: {
  data?: {
    id: string;
    codigoIntegracao: string | null;
    nome: string;
    pessoas: {
      id: string;
      codigoIntegracao: string | null;
      nome: string;
    }[];
    valor: number;
  };
  control: Control<ExportacaoContabilForm, object>;
  index: number;
  nameField: string;
}) {
  return (
    <RowTable>
      <Flex flex={4} gap={2} align="center">
        {data?.nome}
      </Flex>
      <Flex flex={2} fontWeight="medium">
        <Field
          control={control}
          name={`${nameField}.${index}.codigoHistoricoProvisoes`}
          shouldUnregister
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={(v) => field.onChange(v.target.value)}
            />
          )}
        />
      </Flex>
      <Flex flex={2} fontWeight="medium">
        <Field
          control={control}
          name={`${nameField}.${index}.codigoHistoricoBaixas`}
          shouldUnregister
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={(v) => field.onChange(v.target.value)}
            />
          )}
        />
      </Flex>
    </RowTable>
  );
}

export function RowTable({ children }: { children: React.ReactNode }) {
  return (
    <Flex
      w="100%"
      borderX="solid 1px #EBEBEB"
      borderBottom="solid 1px #EBEBEB"
      px={8}
      py={2}
      gap={6}
      align="center"
    >
      {children}
    </Flex>
  );
}
